import React from 'react'
import Strings from '../../lib/Strings'
import Dispatcher from '../../dispatchers/Dispatcher'

export default function TimeOnIceZones({ time, activeZone, activeParentZone }) {
    const handleClick = (zone) => {
        const isParentZone = zone === 'power_play' || zone === 'penalty_kill';
        
        // If no zones are active, only allow base level zones or parent zones
        if (!activeZone && !activeParentZone) {
            if (isParentZone || zone === 'es_off_zone' || zone === 'es_def_zone') {
                console.log('setting base level or parent zone');
                Dispatcher.dispatch({
                    type: 'toi-zone-click',
                    data: {
                        zone: zone,
                        time: time
                    }
                });
            } else {
                console.log('No parent zone active, skipping sub-zone');
            }
            return;
        }

        // Dispatch the zone click - store will handle all the logic
        Dispatcher.dispatch({
            type: 'toi-zone-click',
            data: {
                zone: zone,
                time: time
            }
        });
    }

    // Determine if a zone should be shown as active
    const isZoneActive = (zone) => {
        if (zone === 'power_play' || zone === 'penalty_kill') {
            return activeParentZone && activeParentZone.zone === zone;
        }
        return activeZone && activeZone.zone === zone;
    };

    // Determine which zones to show based on current state
    const getVisibleZones = () => {
        if (activeParentZone) {
            if (activeParentZone.zone === 'power_play') {
                // Keep power_play in the rightmost position, show pp_* options on left
                return ["pp_off_zone", "pp_def_zone", "power_play"];
            } else if (activeParentZone.zone === 'penalty_kill') {
                // Keep penalty_kill in the rightmost position, show pk_* options on left  
                return ["pk_off_zone", "pk_def_zone", "penalty_kill"];
            }
        }
        
        // No parent zone active - show base options with parent buttons on right
        return ["es_off_zone", "es_def_zone", "power_play", "penalty_kill"];
    };

    // "OZ Control", "OZ No Control", "DZ Control" and "DZ No Control"
    // OZ Even, OZ PP, OZ PK, DZ Even, DZ PP, DZ PK
    // more added https://tickets.switchboxinc.com/app/tasks/42820903
    return (
        <div style={{ display: 'flex', width: '100%', gap: '8px' }}>
            {getVisibleZones().map((zone) => (
                <div key={zone} className={`btn ${isZoneActive(zone) ? 'active' : ''}`} style={{ flex: 1 }} onClick={() => handleClick(zone)}>
                    <span>
                        {Strings.titleize(zone)}
                    </span>
                </div>
            ))}
        </div>
    )
}
